import * as PIXI from 'pixi.js';


export default class RadialSpinner extends PIXI.Container 
{
    private _outerRadius: number = null;
    private _innerRadius: number = null;
    private _arrColor: Array<number> = null;

    private _radialMask: PIXI.Graphics = null;

    private _phase: number = null;

    private _donut: PIXI.Graphics = null;
    private _curColor: number = null;



    public set outerRadius( value: number ) { this._outerRadius = value; }
    public set innerRadius( value: number ) { this._innerRadius = value; }
    public set colors( value: Array<number> ) { this._arrColor = value; }


    public constructor() 
    {   
        super();
    }

    public init(): void
    {
        console.assert( this._outerRadius != null, "Spinner.ts :: init() :: this._outerRadius cannot be null." );
        console.assert( this._innerRadius != null, "Spinner.ts :: init() :: this._innerRadius cannot be null." );
        console.assert( this._arrColor != null, "Spinner.ts :: init() :: this._arrColor cannot be null." );

        this._curColor = this._arrColor[ 0 ];

        // The edge could be replaced with image as well.
        this._donut = new PIXI.Graphics();
        this._donut.beginFill( this._curColor, 1 );
        this._donut.drawCircle( 0, 0, this._outerRadius );
        this._donut.endFill();
        this._donut.beginHole();
        this._donut.drawCircle( 0, 0, this._innerRadius );
        this._donut.endFill();
        this.addChild( this._donut );

        this._radialMask = new PIXI.Graphics();
        this._donut.mask = this._radialMask;
        this.addChild(this._radialMask);

        this._phase = 0;
    }
    
    public end(): void {}

    public setProgress( progress: number ): void
    {
        let isDirty: boolean = false;
        if ( progress >= 0.75 )
        {
            if ( this._curColor != this._arrColor[ 1 ] )
            {
                this._curColor = this._arrColor[ 1 ];

                isDirty = true;
            }
        }
        else if ( this._curColor != this._arrColor[ 0 ] )
        {
            this._curColor = this._arrColor[ 0 ];

            isDirty = true;
        }
        if ( isDirty )
        {
            this._donut.clear();
            this._donut.beginFill( this._curColor, 1 );
            this._donut.drawCircle( 0, 0, this._outerRadius );
            this._donut.endFill();
            this._donut.beginHole();
            this._donut.drawCircle( 0, 0, this._innerRadius );
            this._donut.endFill();
        }

        if ( progress == 0 )
        {
            this._donut.mask = null;
            this._radialMask.visible = false;
        }
        else
        {
            this._donut.mask = this._radialMask;
            this._radialMask.visible = true;

            this._phase = 2 * Math.PI * progress;

            const angleStart = 0 - Math.PI / 2;
            const angle = this._phase + angleStart;

            // Calculate target point.
            const x = Math.cos(angleStart) * this._outerRadius;
            const y = Math.sin(angleStart) * this._outerRadius;
            // Redraw mask
            this._radialMask
                .clear()
                .moveTo( 0, 0 )
                .beginFill( 0xffffff, 1 )
                .lineTo( x, y )
                .arc( 0, 0, this._outerRadius, angleStart, angle, true )
                .lineTo( 0, 0 )
                .endFill();
        }
    }
}
